import type { FunctionComponent } from "react";

export type ServiceRowGroupsSkeletonProps = {
  /** How many category headers the loaded list will have. */
  count: number;
};

/**
 * The loading state for the grouped service list.
 *
 * Mirrors `ServiceRowGroups` rather than the rows inside it: the sections start closed, so what appears
 * once the services arrive is a stack of collapsed headers, and a skeleton of individual rows would
 * collapse to a fraction of its height. Container width and header box match the real thing exactly, so
 * only the labels fade in.
 */
export const ServiceRowGroupsSkeleton: FunctionComponent<ServiceRowGroupsSkeletonProps> = ({
  count,
}: ServiceRowGroupsSkeletonProps) => (
  <div className="grid grid-cols-1 md:grid-cols-2 items-start gap-2 mb-4 mt-4 w-full max-w-[300px] md:max-w-none md:w-[608px]">
    {Array.from({ length: count }, (_, index) => (
      <div
        // biome-ignore lint/suspicious/noArrayIndexKey: placeholders have no identity of their own
        key={index}
        data-testid="service-group-skeleton"
        className="animate-pulse flex justify-between items-center gap-3 w-full border-[0.5px] border-neutral-300 rounded py-2.5 px-3"
      >
        <div className="w-1/2 h-4 bg-black-300 rounded-md" />
        <div className="w-4 h-4 bg-black-300 rounded-md shrink-0" />
      </div>
    ))}
  </div>
);
